export const determineReleaseErrorMessage = (totalFiles, totalErrors) => {
    return `${totalErrors}/${totalFiles} releases failed to upload.`;
};
